<template>
  <v-card class="md-ml-0 pt-0 pt-md-2" :elevation="0" width="300">
    <div>
      <v-row no-gutters>
        <v-col cols="12" md="4" class="d-flex justify-center">
          <AvatarComponent
            hasBorder
            size="70"
            :url="pictureUrl(courseData.picture)"
          />
        </v-col>
        <v-col cols="12" md="8" class="my-2">
          <p
            class="body-2 mb-2 font-weight-bold md-text-left text-center">
            {{courseData.countryRank}}. {{courseData.name}}
          </p>
          <p class=" text-caption mb-0 text-center md-text-left">
            {{courseData.stateRankName}} - {{courseData.city}}
          </p>
        </v-col>
      </v-row>
    </div>
    <v-card-actions class="justify-center pt-0 pb-md-2">
      <router-link
        :to="{name: 'courses.home',
          params: {
          coursesCountry: courseData.country.slug,
          namegolf: courseData.slug,
          }
        }"
        class="btnSeemore text-caption">
        <translate>See more</translate>
        <v-icon class="fal fa-arrow-right-long ml-3" color="primary" size="25"></v-icon>
      </router-link>
    </v-card-actions>
  </v-card>
</template>
<script>

export default {
  name: "CardWindowMap",
  props: {
    courseData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
  }
};
</script>